import { Card, Divider } from 'antd';
import clsx from 'clsx';
import Container from 'common/components/container.component';
import Pulsate from 'common/components/pulsate.component';
import React from 'react';
import styles from './style.module.scss';

const CheckoutSkeleton: React.FC = () => {
  return (
    <Container>
      <div className={styles['checkout-page-skeleton-title']}>
        <Pulsate width='50%' height='60px' />
      </div>
      <Divider />
      <div className={styles['checkout-page-skeleton-content']}>
        <div className={styles['child']}>
          <Card style={{ marginBottom: '8px' }} title={<Pulsate width='70%' height='20px' />}>
            <Pulsate width='100%' height='150px' />
          </Card>
          <Card style={{ marginBottom: '8px' }} title={<Pulsate width='70%' height='20px' />}>
            <Pulsate width='100%' height='150px' />
          </Card>
        </div>
        <div className={clsx(styles['child'], styles['scrollable'], styles['bordered'])}>
          <Card style={{ marginBottom: '8px' }} title={<Pulsate width='70%' height='20px' />}>
            <Pulsate width='100%' height='70px' />
          </Card>
          <Card>
            <Pulsate width='100%' height='60px' />
            <Divider />
            <Pulsate width='100%' height='60px' />
            <Divider />
            <Pulsate width='100%' height='60px' />
            <Divider />
            <Pulsate width='100%' height='60px' />
            <Divider />
            <Pulsate width='100%' height='60px' />
          </Card>
        </div>
      </div>
    </Container>
  );
};

export default CheckoutSkeleton;
